/* @ngInject */
const dispatchFields = (
  types,
  dispatchLabels,
  icons
) => {
  const self = {}

  self.id = {
    ref: 'id',
    label: dispatchLabels.fields.id.text,
    icon: icons.id,
    output: false,
  }

  self.date = {
    ref: 'date',
    label: dispatchLabels.fields.date.text,
    icon: icons.date,
    type: types.date,
    required: true,
    messages: dispatchLabels.fields.date.messages,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },
  }

  self.dateBegin = {
    ref: 'dateBegin',
    label: dispatchLabels.fields.dateBegin.text,
    icon: icons.date,
    type: types.date,
    messages: dispatchLabels.fields.dateBegin.messages,
    output: false,
  }

  self.dateEnd = {
    ref: 'dateEnd',
    label: dispatchLabels.fields.dateEnd.text,
    icon: icons.date,
    input: {
      type: types.date,
      messages: dispatchLabels.fields.dateEnd.messages,
    },
    output: false,
  }

  self.hour = {
    ref: 'hour',
    label: dispatchLabels.fields.hour.text,
    icon: icons.dispatch.hour,
    type: types.text(),
    required: true,
    messages: dispatchLabels.fields.hour.messages,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },
  }

  self.prg = {
    ref: 'prg',
    label: dispatchLabels.fields.prg.text,
    icon: icons.dispatch.prg,
    type: types.text(5),
    required: true,
    messages: dispatchLabels.fields.prg.messages,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },
  }

  self.sgm = {
    ref: 'sgm',
    label: dispatchLabels.fields.sgm.text,
    icon: icons.dispatch.sgm,
    type: types.text(5),
    required: true,
    messages: dispatchLabels.fields.sgm.messages,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },
  }

  self.comment = {
    ref: 'comment',
    label: dispatchLabels.fields.comment.text,
    icon: icons.dispatch.comment,
    type: types.textarea,
    required: false,
    messages: dispatchLabels.fields.comment.messages,
    output: {
      sortable: true,
      table: { prefill: false, },
      details: false,
      excel: { prefill: true, },
    },
  }

  self.departure = {
    ref: 'departure',
    label: dispatchLabels.fields.departure.text,
    icon: icons.dispatch.departure,
    type: types.text(),
    required: false,
    messages: dispatchLabels.fields.sgm.messages,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },
  }

  self.delivery = {
    ref: 'delivery',
    label: dispatchLabels.fields.delivery.text,
    icon: icons.dispatch.delivery,
    type: types.text(),
    required: false,
    messages: dispatchLabels.fields.delivery.messages,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },
  }

  self.tractionnaire = {
    ref: 'tractionnaire',
    label: dispatchLabels.fields.tractionnaire.text,
    icon: icons.dispatch.tractionnaire,
    type: types.text(),
    required: false,
    messages: dispatchLabels.fields.tractionnaire.messages,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },
  }

  return self
}
export default dispatchFields



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/dispatch/resources/fields.resource.js